
import React from "react";
import { motion } from "framer-motion";

const skillsData = [
    { name: 'HTML', level: '95%' },
    { name: 'CSS', level: '90%' },
    { name: 'React JS', level: '85%' },
    { name: 'PHP', level: '80%' },
    { name: 'Node.js', level: '75%' },
    { name: 'Express.js', level: '70%' },
    { name: 'MySQL', level: '70%' },
    { name: 'MongoDB', level: '70%' },
];


const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" }
    })
};

const Skills = ({ id }) => (
    <section id={id} className="py-20 px-4">
        <div className="container mx-auto">
                    <motion.h2
                        className="text-3xl md:text-4xl font-bold text-center mb-12 text-white"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={1}
                    >
                        My Skills
                        <div className="w-24 h-1 bg-cyan-400 mx-auto mt-2 rounded"></div>
                    </motion.h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {skillsData.map((skill, idx) => (
                            <motion.div
                                key={skill.name}
                                className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-cyan-500/20 transition-shadow duration-300"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                variants={fadeInUp}
                                custom={idx + 2}
                                whileHover={{ scale: 1.05, rotate: 2 }}
                            >
                                <div className="flex justify-between items-center mb-2">
                                    <motion.h3
                                        className="text-xl font-semibold text-white"
                                        initial={{ color: "#fff" }}
                                        whileInView={{ color: ["#06b6d4", "#fff", "#06b6d4"] }}
                                        viewport={{ once: true, amount: 0.5 }}
                                        transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
                                    >
                                        {skill.name}
                                    </motion.h3>
                                    <span className="text-sm font-medium text-cyan-300">{skill.level}</span>
                                </div>
                                <div className="w-full bg-gray-700 rounded-full h-2.5 mt-2">
                                    <motion.div
                                        className="bg-cyan-400 h-2.5 rounded-full"
                                        style={{ width: skill.level }}
                                        initial={{ scaleX: 0 }}
                                        whileInView={{ scaleX: 1 }}
                                        viewport={{ once: true, amount: 0.5 }}
                                        transition={{ delay: 0.5 + idx * 0.1, duration: 0.7, ease: "easeOut" }}
                                    ></motion.div>
                                </div>
                            </motion.div>
                        ))}
            </div>
        </div>
    </section>
);

export default Skills;
